export default function Footer (){
    return (
        <footer className="text-center border-t bg-gray-950 border-gray-950 py-4 text-white text-xl">
            <small>
                {/* <hr /> */}
            Copyright © {new Date().getFullYear()} |  ZBSPORTS  | All Rights Reserved
                {/* <hr /> */}
            </small>

        </footer>
    )
}